import React, { Component } from "react";
import "./Services.css";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import upIcon from '../../assets/images/up.png';

export default class Services extends Component {
    constructor() {
        super();
        this.state = {
            show: true,
            showDisclaimer: true,
            isVisible: false
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.jumpHome = this.jumpHome.bind(this);
    }

    showModal = () => {
        this.setState({ show: true });
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    hideDisclaimer = () => {
        this.setState({ showDisclaimer: false });
    };

    componentDidMount() {
        this.deleteAllCookies();
        window.addEventListener('scroll', this.toggleVisibility);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.toggleVisibility);
    }

    deleteAllCookies() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }

        localStorage.clear();
        sessionStorage.clear();
    }

    toggleVisibility = () => {
        if (window.pageYOffset > 0) {
            this.setState({ isVisible: true });
        } else {
            this.setState({ isVisible: false });
        }
    };

    jumpHome() {
        document.getElementById("navbarId").scrollIntoView({ behavior: "smooth" });
    }

    render() {
        return (
            <div>
                <div className="introSection" id="introId">
                    <div className="masthead-services">
                        <div className="logo-services">
                            <h1 className="logo-services-title">Services</h1>
                        </div>
                    </div>
                    {this.state.isVisible && (
                        <button className="floatingButton" onClick={this.jumpHome}>
                            <img className="up" src={upIcon} alt="up arrow icon" />
                        </button>
                    )}
                    <Container>
                        <Row className="justify-content-center rowCol">
                            <Col lg={12}>
                                <p className="mainBlurb-services bgBlurb-services blurbMargins">
                                    <span className="blurbTitle-services">Assertive Outreach</span><br/>
                                    Streetlink Homeless Support is a peer-led organisation that prioritises its assertive outreach
                                    program, which aims to engage our homeless and substance-using communities. This
                                    outreach program runs from 2 pm to 2 am daily and offers an emergency 24-hour call-out
                                    service.<br/><br/>
                                    When interacting with our service users, we identify their immediate needs. We then provide
                                    them with relevant information on available services in their area, such as homelessness
                                    support, addiction treatment, and social services, to help them exit their current situation.
                                    <br/><br/>
                                    In cases where a person refuses to engage with state-provided services, SHS will then provide
                                    regular welfare checks for the individual to ensure they have essential supplies such as clean
                                    clothing, tents, and sleeping bags. Additionally, SHS will closely monitor their physical and
                                    mental health in case intervention becomes a requirement.
                                </p>

                                <p className="mainBlurb-services bgBlurb blurbMargins">
                                    <span className="blurbTitle-services">Harm Reduction Works</span><br/>
                                    Harm reduction encompasses practical strategies and ideas intended to minimise the negative
                                    consequences linked to drug use. It promotes social justice founded on the belief in and
                                    respect for the rights of people who use drugs.<br/><br/>
                                    Streetlink provides a non-judgmental, non-coercive dignity based provision of services and
                                    resources to people who use drugs and the communities in which they live to assist them in
                                    reducing associate harm.<br/><br/>
                                    Ensures that individuals who use drugs and those with a history of drug use consistently have
                                    a genuine say in developing programs and policies intended to support them.<br/><br/>
                                    The approach affirms that people who use drugs (PWUD) are the most important factor in
                                    reducing the harms of their drug use. It aims to empower PWUDs to share information and
                                    support each other in developing strategies suited to their circumstances.<br/><br/>
                                    Recognises that the realities of poverty, class, racism, social isolation, past trauma, sex-based
                                    discrimination, and other social inequalities affect both people’s vulnerability to and capacity
                                    for effectively dealing with drug-related harm.<br/><br/>
                                    Streetlink does not attempt to minimise or ignore the real and tragic harm and danger that can
                                    be associated with illicit drug use.
                                </p>

                                <p className="mainBlurb-services bgBlurb-services blurbMargins">
                                    <span className="blurbTitle-services">Key Points</span><br/>
                                    Harm reduction focuses on minimising the health, personal, and social harms associated with
                                    drug use, such as the spread of blood-borne diseases.<br/><br/>
                                    Streetlink provides free and confidential advocacy to people entrapped in homelessness
                                    and/or engaging in substance use.<br/><br/>
                                    Advocacy aims to guarantee that people have their voices heard on issues that profoundly
                                    impact their lives and are of utmost importance to them. It also works to safeguard their
                                    rights.<br/><br/>
                                    Through advocacy, individuals assert their views, raise concerns, and voice complaints about
                                    services and can vigorously defend their human rights, access crucial information, explore
                                    their options, and make well-informed decisions.
                                </p>

                                <p className="mainBlurb-services bgBlurb blurbMargins">
                                    <span className="blurbTitle-services">Implementing It</span><br/>
                                    Advocating on your behalf consists of making phone calls, writing letters/complaints, and
                                    attending meetings. Streetlink will always ensure that all communication accurately reflects
                                    your thoughts and concerns, and must acquire your consent before doing so.<br/><br/>
                                    Streetlink can also assist you with self-advocacy; this means that SHS will support you to
                                    identify who to contact regarding your situation and also work with you on the
                                    communication or we can attend meetings with you where required.<br/><br/>
                                    Remember, Streetlink can never communicate with anybody on your behalf without your
                                    consent. We are not here to make decisions for you, we are here to ensure your voice is heard.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <br />
                <h4>Copyright 2025 Streetlink Homeless Support.</h4>
                <br />
            </div>
        );
    }
}
